import { render, staticRenderFns } from "./prizesAdvancedSet.vue?vue&type=template&id=afd35838&scoped=true"
import script from "./prizesAdvancedSet.vue?vue&type=script&lang=js"
export * from "./prizesAdvancedSet.vue?vue&type=script&lang=js"
import style0 from "./prizesAdvancedSet.vue?vue&type=style&index=0&id=afd35838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd35838",
  null
  
)

export default component.exports